const initializeSiteSearch = () => {
    const $button = $('[data-search-load-more]');
    const $params = $('[data-search-parameters');
    const $results = $('[data-search-results]');

    if (
        $button.length === 0
        || $params.length === 0
        || $results.length === 0
    ) {
        return;
    }

    const params = JSON.parse($params.html());
    let pageNumber = params.page_number ?? 1;

    $button.click(function() {
        pageNumber += 1;
        $.post(
            '/ajax/search',
            {
                action: 'load-more-results',
                ...params,
                page_number: pageNumber,
            },
            function(data) {
                $results.append(data.html);
                if (data.is_last_page) {
                    $button.hide();
                }
            }
        );
    });
};

const initializeResourcesSearch = () => {

    $('[data-resources-search-submit]').click(function() {
        $(this).parents('[data-resources-search-form]').submit();
    });
};

const initialize = () => {

    initializeSiteSearch();
    initializeResourcesSearch();
};

export default {
    initialize,
};

